import { useEffect } from "react";
import { useState } from "react";
import { Portfolio } from "../Data/portfolio";

const Works = () => {

    const [post, setPost] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        const newPort = Portfolio.map(p => {
            fetch(`https://api.apiflash.com/v1/urltoimage?access_key=49e2cb9f15764a4a9671dc8a905954bc&wait_until=page_loaded&url=${p.link}&response_type=json&delay=1`)
            .then(r => r.json())
            .then((data) => {
                p.apiThumb = data.url
            })
            .catch((err) => {
                console.log(err.message);
            });
        return p   
        })

        setPost(newPort)
        setLoading(false)


    }, []);


    return ( 
        <div className="grid grid-cols-2 container mx-auto lg:px-20 py-20 bg-port bg-center bg-no-repeat bg-contain">
            {loading && <div className="text-4xl text-bold animate-pulse flex justify-center items-center col-span-2 h-screen">Loading...</div>}
            {post && post.map(work => {
                return(
                    <div key={work.id} className="col-span-full md:col-span-1 overflow-hidden min-w-[50%] bg-gray-400 rounded-lg m-5 hover:scale-110 transition ease-in"  data-aos="zoom-out-up">
                        <div>
                            <div className="absolute p-4 ">
                                {work.stack && work.stack.map(item => <span key={item.id} className="bg-gray-200 opacity-75 text-sm rounded-full px-2 py-1 m-1 md:m-2">{item}</span>)}
                            </div>
                            
                            <a href={work.link}>
                            <div className="absolute flex flex-col justify-center items-center z-50 opacity-0 hover:opacity-100 hover:bg-opacity-50 h-full w-full bg-black font-rubik">
                                <h2 className="text-sm md:text-2xl font-bold text-white">{work.title}</h2>
                                <h3 className="text-sm md:text-xl text-center text-white p-2">{work.description}</h3>
                            </div>
                                <img src={work.apiThumb ? work.apiThumb : work.thumb} className="h-[250px] w-full z-10 object-cover" alt="Collins Oga codeBro" />
                                {/* <img src="/assets/test.png" className="h-[250px] w-full z-10 object-cover" alt="collins oga" /> */}
                            </a>
                            
                            
                            
                            
                            
                        </div>
                    </div>
                )
            })}
        </div>
     );
}
 
export default Works;